/* eslint-disable */
/* eslint-disable react/prop-types */
import React from 'react';
import { CPagination, CPaginationItem } from '@coreui/react';
import Link from 'next/link';

const Pagination = ({ currentPage, pageCount, language }) => {
  return (
    <CPagination className="mb-0">
      {currentPage === 1 ? (
        <>
          {currentPage === 1 && pageCount === 1 ? (
            <>
              <CPaginationItem disabled={true}>{'Previous'}</CPaginationItem>
              <CPaginationItem active={true}>{currentPage}</CPaginationItem>
              <CPaginationItem disabled={true}>{'Next'}</CPaginationItem>
            </>
          ) : (
            <>
              <CPaginationItem disabled={true}>{'Previous'}</CPaginationItem>
              <CPaginationItem active={true}>{currentPage}</CPaginationItem>
              {pageCount === currentPage + 1 ? (
                <>
                  <Link
                    href={`/blogs?currentPage=${currentPage + 1}`}
                    locale={language === 'ID' ? 'id' : 'en'}
                  >
                    <a>
                      <CPaginationItem
                      // style={{cursor: 'pointer'}}
                      // onClick={() => handleNext(currentPage)}
                      >
                        {currentPage + 1}
                      </CPaginationItem>
                    </a>
                  </Link>
                  <Link
                    href={`/blogs?currentPage=${currentPage + 1}`}
                    locale={language === 'ID' ? 'id' : 'en'}
                  >
                    <a>
                      <CPaginationItem
                      // style={{ cursor: "pointer" }}
                      // onClick={() => handleNext(currentPage)}
                      >
                        {'Next'}
                      </CPaginationItem>
                    </a>
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    href={`/blogs?currentPage=${currentPage + 1}`}
                    locale={language === 'ID' ? 'id' : 'en'}
                  >
                    <a>
                      <CPaginationItem
                      // style={{ cursor: "pointer" }}
                      // onClick={() => handleNext(currentPage)}
                      >
                        {currentPage + 1}
                      </CPaginationItem>
                    </a>
                  </Link>
                  <Link
                    href={`/blogs?currentPage=${currentPage + 2}`}
                    locale={language === 'ID' ? 'id' : 'en'}
                  >
                    <a>
                      <CPaginationItem
                      // style={{ cursor: "pointer" }}
                      // onClick={() => handleNext(currentPage + 1)}
                      >
                        {currentPage + 2}
                      </CPaginationItem>
                    </a>
                  </Link>
                  <Link
                    href={`/blogs?currentPage=${currentPage + 1}`}
                    locale={language === 'ID' ? 'id' : 'en'}
                  >
                    <a>
                      <CPaginationItem
                      // style={{ cursor: "pointer" }}
                      // onClick={() => handleNext(currentPage)}
                      >
                        {'Next'}
                      </CPaginationItem>
                    </a>
                  </Link>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <Link
            href={`/blogs?currentPage=${currentPage - 1}`}
            locale={language === 'ID' ? 'id' : 'en'}
          >
            <a>
              <CPaginationItem
              // style={{ cursor: "pointer" }}
              // onClick={() => handlePre(currentPage)}
              >
                {'Previous'}
              </CPaginationItem>
            </a>
          </Link>
          <Link
            href={`/blogs?currentPage=${currentPage - 1}`}
            locale={language === 'ID' ? 'id' : 'en'}
          >
            <a>
              <CPaginationItem
              // style={{ cursor: "pointer" }}
              // onClick={() => handlePre(currentPage)}
              >
                {currentPage - 1}
              </CPaginationItem>
            </a>
          </Link>
          <CPaginationItem active={true}>{currentPage}</CPaginationItem>
          {currentPage !== pageCount ? (
            <>
              <Link
                href={`/blogs?currentPage=${currentPage + 1}`}
                locale={language === 'ID' ? 'id' : 'en'}
              >
                <a>
                  <CPaginationItem
                  // style={{ cursor: "pointer" }}
                  // onClick={() => handleNext(currentPage)}
                  >
                    {currentPage + 1}
                  </CPaginationItem>
                </a>
              </Link>
              <Link
                href={`/blogs?currentPage=${currentPage + 1}`}
                locale={language === 'ID' ? 'id' : 'en'}
              >
                <a>
                  <CPaginationItem
                  // style={{ cursor: "pointer" }}
                  // onClick={() => handleNext(currentPage)}
                  >
                    {'Next'}
                  </CPaginationItem>
                </a>
              </Link>
            </>
          ) : (
            <>
              <CPaginationItem disabled={true}>{'Next'}</CPaginationItem>
            </>
          )}
        </>
      )}
    </CPagination>
  );
};

export default Pagination;
